module.exports = __webpack_public_path__ + "static/img/cart_empty.66bff4bd.png";